export default "__VITE_ASSET__e7p9CTS0__"